/* eslint-disable no-undef */
import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store'
import CompanySearch from '../views/CompanySearch.vue'
import QuickSearch from '../views/QuickSearch.vue'
import Login from '../views/Login.vue'
import SearchResults from "../views/SearchResults";
import CompanyDetails from "../views/CompanyDetails";
import Error404 from "../views/Error404.vue";
import { resetState } from '../store/reset';

const scrollBehavior = (to, from, savedPosition) => {

	// If not back button then call the resetState function
	if (savedPosition == null && !to.matched.some(m => m.meta.retainState)) {
		resetState(to.name);
	}

	let position = {};
	if (savedPosition) {
		return savedPosition
	} else {
		position.x = 0
		position.y = 0
	}
	return position
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'QuickSearch',
    component: QuickSearch
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/search',
    name: 'CompanySearch',
    component: CompanySearch
  },
  {
    path: '/search/:companySearchId',
    name: 'CompanySearchB',
    component: CompanySearch,
    props: true,
    meta: { retainState: true }
  },
  {
    path: '/results',
    name: 'SearchResults',
    component: SearchResults
  },
  {
    path: '/results/:companySearchId',
    name: 'SearchResultsB',
    component: SearchResults,
    props: true
  },
  {
    path: '/company-details',
    name: 'CompanyDetails',
    component: CompanyDetails
  },
  {
    path: '/company-details/:companyId',
    name: 'CompanyDetailsB',
    component: CompanyDetails,
    props: true
  },
  {
    path: '/company-details/:companySearchId/:companyId',
    name: 'CompanyDetailsC',
    component: CompanyDetails,
    props: true
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  //history: createWebHistory(),
  scrollBehavior,
  routes
})
router.beforeResolve((to, from, next) => { 

  console.log('beforeResolve', to);

	var token = store.getters['authmodule/token'];

	if (typeof window === 'undefined') next();

	if (token === null) {

		store.dispatch('authmodule/updateToken').then(() => {

			token = store.getters['authmodule/token'];

			if (to.name === 'Login' || token !== null) {
				next();
			} else {
				next({ path: '/login' })
			}
			// return;
		});
	} else {
		next();
	}

})
export default router
